/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CANDIDATE_APPLICATION_REFERRAL_CREATE = gql`
  mutation candidateApplicationReferralCreate( $application_referrals: [CandidateApplicationReferralCreateInput!] ) {
    candidate {
      applicationReferrals( create: $application_referrals ) {
        applicationReferrals {
          id
          applicationId
          referrerId
        }
      }
    }
  }
`;
